import React, { useEffect, useRef, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Col,
  Row,
  Card,
  UncontrolledPopover,
  PopoverBody,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import action from "../../../assets/icons/action.svg"
import { toastSuccess } from "../../../helpers/msg_helper"
import closeIcon from "../../../assets/icons/close.svg"
import CustomerFilter from "./filter"
import {
  deleteProject,
  downloadProject,
  searchProjectMaster,
} from "../../../services/projectManager/projectMaster"
import { useLocation, useNavigate } from "react-router-dom"
import { capitalize } from "lodash"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import check from "../../../assets/icons/estimation_check.svg"
import LogoutPopup from "../../../components/VerticalLayout/logoutpopup"

const ProjectMaster = () => {
  const location = useLocation()
  const message = location?.pathname
  console.log("message", message)
  const companyname = localStorage.getItem('companyname')
  document.title = `Project Master ${companyname ? `| ${companyname}` : ''}`;
  const [editClass, setEditClass] = useState({
    modal: false,
    value: "",
    id: "",
  })
  const navigate = useNavigate()
  const [refresh, setRefresh] = useState(0)
  const [viewData, setViewData] = useState()
  const [modal, setModal] = useState(false)

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const toggle = () => setModal(!modal)

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)

  const handleUpdate = () => {
    setRefresh(refresh + 1)
  }
  const handleReset = () => {
    setEditClass({
      modal: false,
      value: "",
      id: "",
    })
  }

  const [classData, setClassData] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [customerType, setCustomerType] = useState("")
  const [page, setPage] = useState("")
  const [projectCode, setProjectCode] = useState("")
  const [customerCode, setCustomerCode] = useState("")
  const [locationId, setLocationId] = useState("")
  const [dataPerPage, setDataPerPage] = useState(25)
  const [count, setCount] = useState(0)
  const [logoutModal, setLogoutModal] = useState(false)
  const [deleteId, setDeleteId] = useState("")
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  const handleEdit = item => {
    setEditClass({ modal: false, value: item, id: item?.id })
  }
  const handleView = item => {
    setViewData(item)
    toggle()
  }
  const handleDeleteProject = item => {
    const updateStatus = async item => {
      const response = await deleteProject(item)
      toastSuccess(response?.message)
      setRefresh(refresh + 1)
    }
    updateStatus(item)
  }

  const handleDownload = async (id, name) => {
    try {
      const fileName = `${name}.pdf`;
      const response = await downloadProject(id, fileName)
      const blob = response.data || response
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", `project_${id}.pdf`)
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
      window.URL.revokeObjectURL(url)
      toastSuccess("Download started")
    } catch (error) {
      console.error(error)
    }
  }
  const columns = [
    {
      label: "Project Code",
      renderCell: item => {
        return (
          <>
            {loggedUser?.permission?.some(
              permissionItem => permissionItem?.name === "workprogress_view"
            ) ? (
              <span
                onClick={() =>
                  // navigate(`/project-master/work-progress/view/${item?.id}`)
                  navigate(`/project-manager-dash/${item?.id}`)
                }
                className="pointer fw-bold pe-1"
              >
                {item?.project_code}
              </span>
            ) : (
              <span className="pe-1">{item?.project_code}</span>
            )}
            {item?.budger_status == 1 && (
              <img src={check} className="est-approve-img" />
            )}
          </>
        )
      },
      // renderCell: item => item?.project_code,
    },
    {
      label: "Project Name",
      renderCell: item => {
        return (
          <div>
            <div id={`project_name_pop_${item?.id}`}>
              {item?.project_name?.length > 30 ? `${capitalize(item?.project_name?.slice(0, 30))}...` : item?.project_name?.length < 30 ? capitalize(item?.project_name) : "-"}
            </div>

          </div>
        )
      },
      sortKey: "project_name",
    },
    {
      label: "Project Location",
      renderCell: item =>
        item?.location?.name ? capitalize(item?.location?.name) : "-",
      sortKey: "name",
    },
    {
      label: "Customer Code",
      renderCell: item => item?.customers?.customer_code,
    },
    {
      label: "Customer Name",
      renderCell: item =>
        item?.customers?.customer_name ? (
          <div className="tbl-word-break pe-2">
            {capitalize(item?.customers?.customer_name)}
          </div>
        ) : (
          "-"
        ),
      sortKey: "customer_name",
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <span
            className={`font-13 ${item?.status === 1 ? "status-active" : "status-inactive"
              }`}
          >
            {item?.status === 1 ? "Active" : "Inactive"}
          </span>
        </div>
      ),
    },
    {
      label: "Action",
      renderCell: item => (
        <>
          <div>
            <span id={`PopoverLegacy-${item?.id}`}>
              <img src={action} alt="" className="pointer" />
            </span>
          </div>
          <UncontrolledPopover
            placement="bottom"
            target={`PopoverLegacy-${item?.id}`}
            trigger="legacy"
          >
            <PopoverBody>
              {item?.budger_status == 0 && (
                <div
                  className="table-popup-content"
                  onClick={() => navigate(`/project-budget/edit/${item?.id}`)}
                >
                  Update Budget
                </div>
              )}
              {item?.budger_status !== 0 && (
                <div
                  className="table-popup-content"
                  onClick={() => navigate(`/project-edit/${item?.id}`, { state: { urldata: item?.budger_status !== 0 } })}
                >
                  Edit
                </div>
              )}
              {item?.budger_status == 1 && (
                <div
                  className="table-popup-content"
                  onClick={() => navigate(`/project-attendance/${item?.id}`)}
                >
                  Daily Attendance
                </div>)}
              {/* {item?.status === 1 && (
                <>
                  <div
                    className="table-popup-content"
                    onClick={() => navigate(`/project-master/edit/${item?.id}`)}
                  >
                    Edit
                  </div>
                </>
              )} */}
              {/* {loggedUser?.permission?.some(
                permissionItem => permissionItem?.name === "workprogress_edit"
              ) ? (
                <div
                  className="table-popup-content"
                  onClick={() =>
                    navigate(`/project-master/work-progress/edit/${item?.id}`)
                  }
                >
                  Update Progress
                </div>
              ) : (
                <></>
              )} */}
              <div
                className="table-popup-content"
                // onClick={() => handleDeleteProject(item?.id)}
                onClick={e => {
                  e.preventDefault()
                  setLogoutModal(true)
                  setDeleteId(item?.id)
                }}
              >
                Delete
              </div>
              <div
                className="table-popup-content"
                onClick={() => handleDownload(item?.id, item?.project_name)}
              >
                Download
              </div>
              {/* <div
                className={`${
                  item?.status === 1 ? "popover-border" : ""
                } table-popup-content`}
                onClick={() => handleActivate(item?.id)}
              >
                {item?.status === 1 ? "Deactivate" : "Activate"}
              </div> */}
            </PopoverBody>
          </UncontrolledPopover>
        </>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handilRest = () => {
    setRefresh(refresh + 1)
  }

  useEffect(() => {
    const fetchClass = async () => {
      const response = await searchProjectMaster({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${search ? `&searchText=${search}` : "&searchText"
          }${`&sortOrder=asc`}${customerType == "0" || customerType == "1"
            ? `&customer_type=${customerType}`
            : ""
          }${page ? `&page=${page}` : ""}${projectCode ? `&project_code=${projectCode}` : ""
          }${customerCode ? `&cus_code=${customerCode}` : ""}${locationId ? `&project_location=${locationId}` : ""
          }${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })
      // setClassData(response)
      const newData = response?.data?.data || [];

      setClassData(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
    }
    fetchClass()
  }, [
    refresh,
    status,
    search,
    customerType,
    page,
    projectCode,
    locationId,
    customerCode,
    dataPerPage
  ])

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }

  const handleCatChange = id => {
    setCustomerType(id)
    setPage(1)
  }
  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }
  const handleProjectCode = data => {
    setProjectCode(data)
    setPage(1)
  }
  const handleLocationId = data => {
    setLocationId(data)
    setPage(1)
  }
  const handleCustomerCode = data => {
    setCustomerCode(data)
    setPage(1)
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < classData?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [classData, page]);
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title={message == "/inventory-project-master" ? "Inventory" : "Project Management"}
              breadcrumbObject={[
                { title: `${message == "/inventory-project-master" ? "Inventory" : "Project Management"}`, link: `${message == "/inventory-project-master" ? "/inventory" : "/project"}` },
                { title: `${message == "/inventory-project-master" ? crumb : crumb }`, link: `${message == "/inventory-project-master" ? "/inventory" : "/project"}` },
                { title: `${message == "/inventory-project-master" ? "Sale Order Reports" : "Project Master"}`, link: `${message == "/inventory-project-master" ? "/inventory-project-master" : "/project-master"}` },
              ]}
            />
            {/* <EditCustomer
              key={"x"}
              onUpdate={handleUpdate}
              onReset={handleReset}
              editValue={editClass}
              buttonLabel="+&nbsp; Customer"
              className="px-2 mb-3 me-2 btn btn-primary"
            /> */}
          </div>
          <Card className="me-2 px-2 pb-2">
            <CustomerFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              handleCatChange={handleCatChange}
              handleProjectCode={handleProjectCode}
              handleLocationId={handleLocationId}
              handleCustomerCode={handleCustomerCode}
              sampleUrl={"download/customer.xlsx"}
              importUrl={"customer/import"}
              isImport={false}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                <div ref={tableContainerRef} style={{ height: "490px", overflowY: "auto" }}>
                  {classData && (
                    <UpdateTable
                      className="mt-5"
                      nodes={classData?.data?.data}
                      paginate={classData?.data}
                      CurrentPage={page}
                      columns={columns}
                      handlePagination={handlePaginate}
                      handleSizePerPage={handleSizePerPageChange}
                      tableWidth="10% 20% 15% 15% 20% 10% 10%"
                      mobileWidth="20% 40% 30% 30% 40% 20% 10%"
                      isLoading={isLoadingNextPage}
                      hidePaginate={true}
                    />
                  )}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
      <Modal isOpen={modal} toggle={toggle} size="lg" unmountOnClose={false}>
        <>
          <ModalHeader className="custom-modal-header">
            <div className="d-flex justify-content-between">
              <h5 className="ms-4">Details</h5>
              <img
                src={closeIcon}
                alt=""
                onClick={toggle}
                width="10"
                role="button"
              />
            </div>
          </ModalHeader>
          <ModalBody>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Customer Type
              </Col>
              <Col className="primary-text">
                {viewData?.customer_type?.label}
              </Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Customer Code
              </Col>
              <Col className="primary-text">{viewData?.customer_code}</Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Customer Name
              </Col>
              <Col className="primary-text">{viewData?.customer_name}</Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Customer Person
              </Col>
              <Col className="primary-text">{viewData?.contact_person}</Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Customer Number
              </Col>
              <Col className="primary-text">{viewData?.customer_number}</Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Designation
              </Col>
              <Col className="primary-text">
                {viewData?.contact_person_designation}
              </Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Email ID
              </Col>
              <Col className="primary-text">{viewData?.email_id}</Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Fax Number
              </Col>
              <Col className="primary-text">{viewData?.fax_number}</Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Address
              </Col>
              <Col className="primary-text">{viewData?.address}</Col>
            </Row>
          </ModalBody>
        </>
      </Modal>
      <LogoutPopup
        isOpen={logoutModal}
        toggle={() => setLogoutModal(!logoutModal)}
        ProjectMaster={true}
        deleteId={deleteId}
        handilRest={handilRest}
      />
    </React.Fragment>
  )
}

export default ProjectMaster
